import React from 'react';
interface ProductCardProps {
  title: string;
  description: string;
  image: string;
  formats: string[];
  badge?: string;
}
export function ProductCard({
  title,
  description,
  image,
  formats,
  badge
}: ProductCardProps) {
  return <div className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-224">
      {/* Image */}
      <div className="relative h-64 bg-gradient-to-br from-pink-100 to-purple-100" data-id="element-225">
        <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-226" />
        {badge && <div className="absolute top-4 right-4 bg-gold-400 text-navy-900 px-4 py-2 rounded-full text-sm font-bold shadow-lg" data-id="element-227">
            {badge}
          </div>}
      </div>

      {/* Content */}
      <div className="p-6 space-y-4" data-id="element-228">
        <h3 className="font-serif text-2xl text-navy-900 font-bold" data-id="element-229">{title}</h3>

        <p className="text-gray-600 leading-relaxed" data-id="element-230">{description}</p>

        {/* Formats */}
        <div className="flex gap-3 pt-2" data-id="element-231">
          {formats.map((format, index) => <span key={index} className="text-2xl" title={format} data-id="element-232">
              {format}
            </span>)}
        </div>
      </div>
    </div>;
}